import * as React from 'react';
import { useSelector } from 'react-redux';

import { TourButton } from '../../../components/NewbuildingTiledCarousel/TourButton';
import { Tour } from '../../../components/TourContainer';
import { virtualTourKeySelector } from '../../../selectors/newObject/getTour';
import { FullscreenWrapperContainer } from '../../FullscreenWrapper';
import { track3DTourFullscreen } from '../../TourContainer/tracking';
import { trackTourButtonClick } from './tracking';

// Покрыты все основные сценарии
/* istanbul ignore next */
export const TourPopupContainer = () => {
  const [isOpen, setIsOpen] = React.useState(false);
  const tourFrameRef = React.useRef<HTMLIFrameElement>(null);
  const tourKey = useSelector(virtualTourKeySelector);

  const tourKeyWithoutFullscreen = React.useMemo(() => {
    if (!tourKey) {
      return '';
    }

    return `${tourKey}${tourKey.includes('?') ? '&' : '?'}fullscreen=no`;
  }, [tourKey]);

  const handler = React.useCallback(() => {
    setIsOpen(true);
    trackTourButtonClick();
  }, []);

  const handleFullscreenClose = React.useCallback(() => {
    setIsOpen(false);
    track3DTourFullscreen('close');
  }, []);

  if (!tourKey) {
    return null;
  }

  return (
    <>
      {isOpen && (
        <FullscreenWrapperContainer isFullScreenInitialState={true} onFullscreenClose={handleFullscreenClose}>
          <Tour frameRef={tourFrameRef} tourUrl={tourKeyWithoutFullscreen} />
        </FullscreenWrapperContainer>
      )}

      <TourButton handler={handler} />
    </>
  );
};

TourPopupContainer.displayName = 'TourPopupContainer';
